/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPasswordCharacters } from './CRSFPasswordCharacters';
import {
    CRSFPasswordCharactersFromJSON,
    CRSFPasswordCharactersFromJSONTyped,
    CRSFPasswordCharactersToJSON,
} from './CRSFPasswordCharacters';
import type { CRSFPasswordComposition } from './CRSFPasswordComposition';
import {
    CRSFPasswordCompositionFromJSON,
    CRSFPasswordCompositionFromJSONTyped,
    CRSFPasswordCompositionToJSON,
} from './CRSFPasswordComposition';

/**
 * 
 * @export
 * @interface CRSFPasswordsAggregate
 */
export interface CRSFPasswordsAggregate {
    /**
     * 
     * @type {CRSFPasswordCharacters}
     * @memberof CRSFPasswordsAggregate
     */
    characters: CRSFPasswordCharacters;
    /**
     * 
     * @type {CRSFPasswordComposition}
     * @memberof CRSFPasswordsAggregate
     */
    composition: CRSFPasswordComposition;
}

/**
 * Check if a given object implements the CRSFPasswordsAggregate interface.
 */
export function instanceOfCRSFPasswordsAggregate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "characters" in value;
    isInstance = isInstance && "composition" in value;

    return isInstance;
}

export function CRSFPasswordsAggregateFromJSON(json: any): CRSFPasswordsAggregate {
    return CRSFPasswordsAggregateFromJSONTyped(json, false);
}

export function CRSFPasswordsAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPasswordsAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'characters': CRSFPasswordCharactersFromJSON(json['characters']),
        'composition': CRSFPasswordCompositionFromJSON(json['composition']),
    };
}

export function CRSFPasswordsAggregateToJSON(value?: CRSFPasswordsAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'characters': CRSFPasswordCharactersToJSON(value.characters),
        'composition': CRSFPasswordCompositionToJSON(value.composition),
    };
}

